module.exports = __webpack_public_path__ + "img/img0401.8a5c2328.png";